import { zodResolver } from "@hookform/resolvers/zod";
import { useCallback } from "react";
import { Controller, useForm } from "react-hook-form";

import { Button } from "~/components/Button";
import { TextInput } from "~/components/TextInput";
import { documentNumberMask } from "~/components/TextInput/utils/mask";

import {
	type PersonalTrainerSignInDTO,
	schema,
} from "../../../modules/authentication/schema";

type Props = {
	onSubmit: (payload: PersonalTrainerSignInDTO) => Promise<void>;
	buttonLabel?: string;
};

export const LoginForm: React.FC<Props> = ({
	onSubmit,
	buttonLabel = "Entrar",
}) => {
	const {
		control,
		register,
		handleSubmit,
		formState: { errors, isSubmitting },
	} = useForm<PersonalTrainerSignInDTO>({
		resolver: zodResolver(schema),
	});

	const handleSubmitForm = useCallback(
		async (formData: PersonalTrainerSignInDTO) => {
			await onSubmit(formData);
		},
		[onSubmit],
	);

	return (
		<form
			className="flex flex-col w-full gap-3"
			onSubmit={handleSubmit(handleSubmitForm)}
			autoComplete="off"
		>
			<Controller
				control={control}
				name="documentNumber"
				defaultValue=""
				render={({ field }) => (
					<TextInput
						error={errors.documentNumber?.message}
						label="CPF"
						inputMode="numeric"
						value={field.value}
						onChange={(e) => field.onChange(documentNumberMask(e.target.value))}
					/>
				)}
			/>
			<TextInput
				{...register("password")}
				autoCapitalize="off"
				error={errors.password?.message}
				label="Senha"
				type="password"
			/>
			<Button loading={isSubmitting}>{buttonLabel}</Button>
		</form>
	);
};
